export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000',
  stripePublicKey:
    'pk_test_51QUGxiCDMohLUYvDNQpwTxIJSBEQIRbRk4UOSRdI36ZmFHZShh1PCqlqThiurEpPVAOBmZw2mcslg1lmDCymBqdL009OsH7xsj',
  stripeReturnHost: 'http://localhost:4200',
  stripeReturnHostIsLocalized: false,
  supportEmail: 'support@fluentstride.com',
  appUrlAppleStore: 'https://apps.apple.com/us/app/fluentstride/id6463647486',
  appUrlGoogleStore:
    'https://play.google.com/store/apps/details?id=com.fluentstride.app',
};
